import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import CommentItemComponent from './CommentItemComponent';
import CommentFormComponent from './CommentFormComponent';
import LoginRegisterPopup from '../Login/LoginRegisterPopup';

class CommentsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      comments: props.comments,
      showModal: false,
      loading: false,
    };

    this.handleCreate = this.handleCreate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleReply = this.handleReply.bind(this);
    this.handleUndelete = this.handleUndelete.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  handleCreate(comment) {
    axios
      .post('/api/v1/comments', {
        lobsters: { comment },
        story: { id: this.props.storyId },
      })
      .then(({ data }) => this.setState({ comments: data }));
  }

  handleReply(commentParams) {
    axios
      .post('/api/v1/comments', {
        lobsters: commentParams,
        story: { id: this.props.storyId },
      })
      .then(({ data }) => this.setState({ comments: data }));
  }

  handleUpdate(comment) {
    axios
      .put(`/api/v1/comments/${comment.id}`, {
        lobsters: { comment: comment.comment },
        story: { id: this.props.storyId },
      })
      .then(({ data }) => this.setState({ comments: data }));
  }

  handleDelete(comment) {
    axios
      .delete(`/api/v1/comments/${comment.id}`)
      .then(({ data }) => this.setState({ comments: data }));
  }

  handleUndelete(comment) {
    axios
      .put(`/api/v1/comments/${comment.id}/undelete`)
      .then(({ data }) => this.setState({ comments: data }));
  }

  toggleModal() {
    this.setState({ showModal: !this.state.showModal });
  }

  renderLoginRegisterPopup() {
    return (
      <LoginRegisterPopup
        showModal={!!this.state.showModal}
        handleToggle={this.toggleModal}
        loading={!!this.state.loading}
        authenticityToken={this.props.authenticityToken}
        loginAction={this.props.loginAction}
        rergisterAction={this.props.registerAction}
        newUserConfimationPath={this.props.newUserConfimationPath}
        usernameValidationPath={this.props.usernameValidationPath}
        newUserPasswordPath={this.props.newUserPasswordPath}
        newUserUnlockPath={this.props.newUserUnlockPath}
      />
    );
  }

  render() {
    const commentItems = this.state.comments.map(comment => (
      <CommentItemComponent
        key={comment.short_id}
        currentUser={this.props.currentUser}
        onDelete={this.handleDelete}
        onUndelete={this.handleUndelete}
        onUpdate={this.handleUpdate}
        onReply={this.handleReply}
        comment={comment}
      />
    ));

    return (
      <section id="comments">
        <CommentFormComponent
          onSubmit={this.handleCreate}
          disable={!this.props.currentUser}
          toggleModal={this.toggleModal}
          fixed
        />

        <ul className="comments">
          {commentItems.length === 0 &&
            <p style={{ color: '#a9c0ce', fontStyle: 'italic' }}>
              There are no comments yet.
            </p>
          }
          {commentItems}
        </ul>

        {this.renderLoginRegisterPopup()}
      </section>
    );
  }
}

CommentsComponent.propTypes = {
  storyId: PropTypes.number.isRequired,
  loginAction: PropTypes.string.isRequired,
  registerAction: PropTypes.string.isRequired,
  newUserConfimationPath: PropTypes.string.isRequired,
  usernameValidationPath: PropTypes.string.isRequired,
  newUserPasswordPath: PropTypes.string.isRequired,
  newUserUnlockPath: PropTypes.string.isRequired,
};

export default CommentsComponent;
